import React, { useMemo } from 'react';
import { motion } from 'framer-motion';
import { FiTrendingUp } from 'react-icons/fi';
import { useQueries } from 'react-query';
import { getBaseRate } from 'features/finance/api/getBaseRate';
import { SecureText } from 'components/Elements';
import { ROLES } from 'lib/authorization';

export const TotalAccountingBalance = ({ wallets = [] }) => {
  const quoteCurrency = 184;

  console.log(wallets);

  const baseRateQueries = useQueries(
    wallets.map((wallet) => ({
      queryKey: ['baseRate', wallet.currencyId, quoteCurrency],
      queryFn: () =>
        getBaseRate({
          baseCurrency: wallet.currencyId,
          quoteCurrency,
        }).then((res) => res?.data?.rate?.rate || 0),
      enabled: !!wallet.currencyId,
    }))
  );

  const isLoading = baseRateQueries.some((q) => q.isLoading || q.isFetching);

  const totalNGNBalance = useMemo(() => {
    if (isLoading) return null;

    return wallets.reduce((total, wallet, index) => {
      const balance = parseFloat(wallet.balance || '0');
      const rate = baseRateQueries[index]?.data || 0;
      return total + balance * rate;
    }, 0);
  }, [wallets, baseRateQueries, isLoading]);

  const formattedBalance =
    totalNGNBalance !== null
      ? totalNGNBalance.toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
      : null;

  return (
    <motion.div
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, ease: 'easeOut' }}
      className="relative bg-white/10 backdrop-blur-lg border border-white/10 rounded-2xl p-6 shadow-md text-white overflow-hidden"
    >
      {/* Icon and title */}
      <div className="flex items-center gap-3 mb-2">
        <div className="bg-white/10 p-2 rounded-full">
          <FiTrendingUp size={18} className="text-white" />
        </div>
        <span className="text-sm text-white/60 uppercase tracking-wider">
          Vault Balance (UGX)
        </span>
      </div>

      {/* Final balance or loading */}
      <div className="text-3xl font-bold">
        {isLoading ? (
          <div className="h-8 w-36 bg-white/20 rounded-full animate-pulse" />
        ) : (
          <SecureText
            value={`UGX ${formattedBalance}`}
            allowedRoles={[ROLES.ROOT_USER, ROLES.TRANSACTION_MANAGER]}
            // requiredPermissions={['viewCustomerProfiles']}
            className="text-sm"
          />
        )}
      </div>

      {/* Shine overlay */}
      <div className="absolute inset-0 pointer-events-none rounded-2xl bg-gradient-to-br from-white/10 to-transparent opacity-10 blur-sm" />
    </motion.div>
  );
};
